import { DOG_CARD_GRID_COLS_CLASS } from "@/components/shared/dogCardGrid";
import type { ReactNode } from "react";
import { DogCard } from "@/features/listings";
import { ProviderListingsSection } from "../ProviderListingsSection";
import {
    type ProviderDogListingCard,
    providerSummaryToCard,
} from "../provider-listing-card";
import { ProfileEmptyState } from "@/components/shared";
import type { CollectionWagsListing } from "@/features/listings";

export const NO_PUPPIES_LABEL = "No puppies available right now";

function mapProviderListingToPuppyCard(
    listing: CollectionWagsListing,
    index: number,
    fallbackImageUrl: string | undefined,
): ProviderDogListingCard {
    return providerSummaryToCard(listing, {
        fallbackName: `Puppy ${index + 1}`,
        fallbackImageUrl,
    });
}

function PuppyDogCard({
    dog,
    priority,
}: {
    dog: ProviderDogListingCard;
    priority?: boolean;
}) {
    return (
        <DogCard
            measurementSurface="provider"
            id={dog.id}
            name={dog.name}
            imageUrl={dog.imageUrl}
            breedNames={dog.breedNames}
            status={dog.status}
            priceRange={dog.priceRange}
            variant="overlay"
            priority={priority}
        />
    );
}

export function AvailablePuppiesSection({
    availablePuppyCards,
    breederName,
    providerId,
    totalPuppyCount,
    availableCount,
    fallbackImageUrl,
    mobileDescription,
}: {
    availablePuppyCards: ProviderDogListingCard[];
    breederName: string;
    providerId: string;
    totalPuppyCount: number;
    availableCount: number;
    fallbackImageUrl?: string;
    mobileDescription?: ReactNode;
}) {
    return (
        <ProviderListingsSection
            initialCards={availablePuppyCards}
            providerId={providerId}
            totalCount={totalPuppyCount}
            availableCount={availableCount}
            fallbackImageUrl={fallbackImageUrl}
            mobileDescription={mobileDescription}
            mobileTitle="Available puppies"
            viewAllTitle="Available Puppies"
            searchPlaceholder="Search puppies by name or breed"
            mapListingToCard={mapProviderListingToPuppyCard}
            renderCard={(dog, index = Number.POSITIVE_INFINITY, surface) => (
                <PuppyDogCard
                    dog={dog}
                    priority={surface === "mobile" && index === 0}
                />
            )}
            desktopGridClassName={DOG_CARD_GRID_COLS_CLASS}
            emptyState={
                <ProfileEmptyState
                    title={NO_PUPPIES_LABEL}
                    description={`${breederName} doesn't have any puppies listed at the moment. Check out similar breeders nearby.`}
                />
            }
        />
    );
}
